{
  "version": 1,
  "asset_id": "90acadd6-3673-4be8-8bc1-4f03306a05b3",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/90acadd6-3673-4be8-8bc1-4f03306a05b3/capital-pro-crew-stamped-concrete.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/90acadd6-3673-4be8-8bc1-4f03306a05b3/capital-pro-crew-stamped-concrete.webp",
  "original_filename": "capital-pro-crew-stamped-concrete.webp",
  "size": 139674,
  "content_type": "image/webp",
  "created_at": "2026-09-11T22:26:13Z"
}
